import React from 'react';
import PropTypes from 'prop-types';

import DataGridVisualizer from './data-grid-visualizer/data-grid-visualizer';
import FeedbackVisualizer from './feedback-visualizer/feedback-visualizer';
import GeospatialHeatmapVisualizer from './geospacial-heatmap-visualizer/geospatial-heatmap-visualizer';
import HierarchyKeyFigureVisualizer from './hierarchy-key-figure-visualizer';
import HierarchyVisualizer from './hierarchy-visualizer/hierarchy-visualizer';
import HighChartsGaugeVisualizer from './highcharts-gauge-visualizer/highcharts-gauge-visualizer';
import HighChartsVisualizer from './highcharts-visualizer/highcharts-visualizer';
import KeyFigureVisualizer from './key-figure-visualizer/key-figure-visualizer.container';
import ListWithSumVisualizer from './list-with-sum-visualizer/list-with-sum-visualizer';
import ReviewVisualizer from './review-visualizer/review-visualizer';
import TableVisualizer from './table-visualizer/table-visualizer';
import TresholdVisualizer from './threshold-visualizer/threshold-visualizer';
import PdfVisualizer from './pdf-visualizer';

const visualizers = {
  DataGridVisualizer,
  FeedbackVisualizer,
  GeospatialHeatmapVisualizer,
  HierarchyKeyFigureVisualizer,
  HierarchyVisualizer,
  HighChartsGaugeVisualizer,
  HighChartsVisualizer,
  KeyFigureVisualizer,
  ListWithSumVisualizer,
  ReviewVisualizer,
  TableVisualizer,
  TresholdVisualizer,
  PdfVisualizer,
};

const VisualizerSelector = (props) => {
  const { visualizerName } = props;
  const MatchingVisualizer = visualizers[visualizerName];

  if (!MatchingVisualizer) {
    console.error(`${visualizerName} is not a valid filter`);
    return 'Widgettyp konnte nicht gefunden werden.';
  }

  return <MatchingVisualizer {...props} />;
};

VisualizerSelector.propTypes = {
  visualizerName: PropTypes.string.isRequired,
};

export default VisualizerSelector;
